import { LocalStoragePersistedObservable } from "../utils/local_storage_persisted_observable";

class SettingsStore {

	wordsUppercase = new LocalStoragePersistedObservable<boolean>('settings_words_uppercase', true);
	errorsThreshold = new LocalStoragePersistedObservable<number>('settings_errors_threshold', 0.5);
	readEveryWord = new LocalStoragePersistedObservable<boolean>('settings_read_every_word', false);

	constructor() {
	}

}

export const SETTINGS_STORE = new SettingsStore();